export class NotImplementedEndpointException extends Error {}
